<template>
  <div class="v-atlas-raumplanung-attribute-info">
    <LoadingIndicatorOverlay v-if="isLoadingDelayed" />

    <div v-else-if="error" class="v-atlas-raumplanung-attribute-info__error">
      <p>Die Metadaten für diesen Indikator konnten nicht geladen werden.</p>
    </div>

    <div v-else-if="responseData" class="v-atlas-raumplanung-attribute-info__content">


      <section v-if="responseData.attrMetadata.description" class="v-atlas-raumplanung-attribute-info__section">
        <h3>Beschreibung</h3>
        <p>{{ responseData.attrMetadata.description }}</p>
      </section>

      <section v-if="responseData.attrMetadata.unit" class="v-atlas-raumplanung-attribute-info__section">
        <h3>Einheit</h3>
        <p>{{ responseData.attrMetadata.unit }}</p>
      </section>



      <section class="v-atlas-raumplanung-attribute-info__section">
        <h3>Quellen</h3>

        <ul v-if="responseData.attrMetadata.sources instanceof Array && responseData.attrMetadata.sources.length > 0">
          <li v-for="source of responseData.attrMetadata.sources">

            {{ source }}
          </li>
        </ul>
        <p v-else>- Keine Quellen angegeben -</p>

      </section>


    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { LoadingIndicatorOverlay, useDelayedBoolean, useSmartFetch } from "gertrud";
import { RaumplanungAttributeMetadataResponse } from "atlas-shared";

const props = defineProps<{
  attrName: string
  serviceBaseUrl: string
}>()

const metadataUrl = computed(() => {
  const attrName = props.attrName;
  if (!attrName) return "";

  return props.serviceBaseUrl + "/attributeMetadata/" + encodeURIComponent(attrName);
})

const { data: responseData, error, isLoading } = useSmartFetch<RaumplanungAttributeMetadataResponse>(metadataUrl);

const isLoadingDelayed = useDelayedBoolean(isLoading, 350, 0);
</script>
